import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';

import type { ExperiencesResponse } from 'app/typings/core/extranet/hotel/experiences';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useHotelExperiences(hotelId?: number) {
  return useQuery<ExperiencesResponse | null>({
    queryKey: [CORE_QUERY_KEYS.hotelExperiences, { id: hotelId }],
    queryFn: () =>
      hotelId
        ? (apiRequest({
            path: ENDPOINTS.getHotelExperiences,
            params: { id: hotelId.toString() },
          }) as Promise<ExperiencesResponse>)
        : Promise.resolve(null),
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    enabled: !!hotelId,
  });
}
